export default __webpack_public_path__ + "4873350f4b58c5f78608f8beeb52bfc1.png";